import React from "react";
import "../../../css/components/reusable/modals/InvoiceSummary.css"; 

const InvoiceSummary = ({ invoice, isIGST, isGST }) => {
    return (
        <div className="invoice-summary-card">
            <h3 className="invoice-summary-title">Invoice Summary</h3>

            <div className="invoice-summary-row">
                <span>Taxable Amount</span>
                <span>₹ {invoice?.taxable_amount || 0}</span>
            </div>

            { isIGST && (
                <div className="invoice-summary-row">
                    <span>IGST</span>
                    <span>₹ {invoice?.igst_amount || 0}</span>
                </div>
            )}

            { isGST && (
                <>
                    <div className="invoice-summary-row">
                        <span>CGST</span>
                        <span>₹ {invoice?.cgst_amount || 0}</span>
                    </div>

                    <div className="invoice-summary-row">
                        <span>SGST</span>
                        <span>₹ {invoice?.sgst_amount || 0}</span>
                    </div>
                </>
            )}

            <div className="invoice-summary-row">
                <span>Total Tax</span>
                <span>₹ {invoice?.total_tax || 0}</span>
            </div>

            <div className="invoice-summary-divider"></div>

            <div className="invoice-summary-row invoice-summary-grand-total">
                <span>Grand Total</span>
                <span>₹ {invoice?.grand_total || 0}</span>
            </div>
        </div>
    );
};

export default InvoiceSummary;
